exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._18k_cEQ6vNiNe9ryhlhRhz{font-size:14px;font-weight:400;font-weight:600;color:\"[theme:neutralPrimary, default:#333333]\"}._18k_cEQ6vNiNe9ryhlhRhz._1BUXOnEMVxkGzMR2tzBzBR{text-decoration:line-through}._2wrKIY8VBE_4u_MzIV2tD8{height:14px;width:14px;min-width:14px}html[dir=ltr] ._2wrKIY8VBE_4u_MzIV2tD8{margin-right:4px}html[dir=rtl] ._2wrKIY8VBE_4u_MzIV2tD8{margin-left:4px}._1ysc5lRX2PgrfB1wHcumVh{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}._3PCVaOnRPB25b6qPR7f_uT{font-size:12px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}", ""]);

// exports
exports.locals = {
	"subject": "_18k_cEQ6vNiNe9ryhlhRhz",
	"isCancelled": "_1BUXOnEMVxkGzMR2tzBzBR",
	"charm": "_2wrKIY8VBE_4u_MzIV2tD8",
	"timeSecondaryText": "_1ysc5lRX2PgrfB1wHcumVh",
	"timePrimaryText": "_3PCVaOnRPB25b6qPR7f_uT"
};